/**
 * Keycloak URL configuration
 *
 * This file provides URL helpers for Keycloak UI redirects.
 * Authentication API calls are now handled through the FastAPI backend.
 */

// Keycloak configuration from environment variables
export const KEYCLOAK_CLIENT_ID =
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "atlas-frontend";
export const KEYCLOAK_URL =
  process.env.REACT_APP_KEYCLOAK_URL || "https://keycloak-atlas.isitics.com/";
export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM || "master";

const getKeycloakBaseUrl = () => KEYCLOAK_URL.replace(/\/+$/, "");

/**
 * Get Keycloak password reset URL (redirects to Keycloak UI)
 */
export const getKeycloakPasswordResetUrl = (redirectUri: string) => {
  const params = new URLSearchParams({
    client_id: KEYCLOAK_CLIENT_ID,
    response_type: "code",
    scope: "openid",
    redirect_uri: redirectUri,
  });

  return `${getKeycloakBaseUrl()}/realms/${KEYCLOAK_REALM}/protocol/openid-connect/forgot-credentials?${params.toString()}`;
};

/**
 * Get Keycloak Account Console URL (for self-service management)
 */
export const getKeycloakAccountConsoleUrl = () => {
  return `${getKeycloakBaseUrl()}/realms/${KEYCLOAK_REALM}/account`;
};
